import { Skeleton } from '@ferreri/prever-component-lib';
import { createNElements } from '../../utils/createNElements';

type SkeletonListProps = {
  elements?: number;
  height?: number;
  maxWidth?: number | string;
  width?: number | string;
};

export const SkeletonList = (props: SkeletonListProps) => {
  const height = props.height || 90;

  return (
    <>
      {createNElements(props.elements).map((_, i) => (
        <Skeleton
          key={i}
          height={height}
          width={props.width}
          maxWidth={props.maxWidth}
        />
      ))}
    </>
  );
};
